// extracted by mini-css-extract-plugin
module.exports = {"wsibgli":"wsibgli"};